import { TAG_COLOR_TO_BAR_COLOR } from "@/constants/colors";
import type { ProjectStatus, ProjectStatusColor } from "@/types";

export const PROJECT_STATUS_FILTER_OPTIONS: ProjectStatus[] = [
  "assessment",
  "report",
  "signatures",
  "on_hold",
  "completed",
  "canceled",
];

export const projectStatusColorMap: Record<ProjectStatus, ProjectStatusColor> = {
  assessment: "Secondary",
  report: "Neutral",
  signatures: "Info",
  on_hold: "Warning",
  completed: "Success",
  canceled: "Danger",
};

export const projectStatusLabelMap: Record<ProjectStatus, string> = {
  assessment: "Assessment",
  report: "Report",
  signatures: "Signatures",
  on_hold: "On Hold",
  completed: "Completed",
  canceled: "Canceled",
};

export const projectStatusBarColorMap = Object.fromEntries(
  Object.entries(projectStatusColorMap).map(([k, v]) => [
    k,
    TAG_COLOR_TO_BAR_COLOR[v as ProjectStatusColor],
  ])
) as Record<ProjectStatus, string>;
